import React from "react";
import { Accordion, Button, Col, Row } from "react-bootstrap";
import { Strings } from "../../resources/i18n/i18n";
import Utility from "../../utils/Utility";
import _ from "lodash";
import Resizer from "react-image-file-resizer";
import { FILE_CONFIGURATIONS, LOAN_APPLICATION_STATUS, MOTORCYCLE_FILE_SIZE } from "../../constants/appConstants";
import { EVIDENCE_SECTIONS, EVIDENCE_SECTIONS_OBJECT, PHOTO_UPLOAD_LIMITS } from "../CreateLoan/CreateLoanConstants";
import cross from "../../resources/images/ic_cross_blue.svg";
import "./Evidence.scss"
import UserModal from "../CustomUIComponents/UserModal/UserModal";
import { LOAN_TYPES } from "../AnalystApproval/Constants";
class Evidence extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeAccordionKey: '0',
            selectedPhoto: null,
            evidence: {
                LOCAL_PHOTO: this.props.documents.LOCAL_PHOTO,
                INVOICE: this.props.documents.INVOICE,
                PHOTOID: this.props.documents.PHOTOID,
                EXTERNAL_INVOICE: this.props.documents.EXTERNAL_INVOICE,
                APPLICATION_SIGNATURE: this.props.documents.APPLICATION_SIGNATURE
            },
            errorMessage: ""
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.errorMessage !== this.props.errorMessage) {
            this.setState({ errorMessage: this.props.errorMessage });
        }
    }

    componentDidMount() {
        const { documents } = this.props;
        if (Array.isArray(documents)) {
            const documentsArray = documents || [];

            const sectionKeys = EVIDENCE_SECTIONS;

            const parsedEvidence = {
                LOCAL_PHOTO: [],
                INVOICE: [],
                PHOTOID: [],
                EXTERNAL_INVOICE: [],
                APPLICATION_SIGNATURE: []
            };

            documentsArray.forEach(doc => {
                const { type, s3Url, documentId } = doc;
                let encryptedUrl = Utility.getDecryptedData(s3Url);
                const imageObj = {
                    file: null,
                    preview: encryptedUrl,
                    documentId: documentId
                };
                if (type === EVIDENCE_SECTIONS_OBJECT.PHOTOID_FRONT || type === EVIDENCE_SECTIONS_OBJECT.PHOTOID_BACK) {
                    parsedEvidence.PHOTOID.push(imageObj);
                } else if (sectionKeys.includes(type)) {
                    parsedEvidence[type].push(imageObj);
                }
            });

            this.setState({
                evidence: parsedEvidence
            });
        }
        else {
            this.setState({
                evidence: documents
            });
        }

    }


    validateData = () => {
        this.props.scrollToTop();
        const { evidence } = this.state;
        const { selectedLoanType } = this.props;
        const missingSections = [];

        Object.keys(PHOTO_UPLOAD_LIMITS).forEach((sectionKey) => {
            if (
                sectionKey === "EXTERNAL_INVOICE" &&
                selectedLoanType !== LOAN_TYPES.EXTERNAL_FACTORING
            ) {
                return;
            }

            const uploadedCount = evidence[sectionKey]?.length || 0;
            const requiredCount =
                sectionKey === "EXTERNAL_INVOICE" ? 1 : PHOTO_UPLOAD_LIMITS[sectionKey];

            if (uploadedCount < requiredCount) {
                missingSections.push(Strings(sectionKey));
            }
        });

        if (missingSections.length > 0) {
            const formattedSections = missingSections.join(", ");
            this.setState({
                errorMessage: `${Strings("pleaseUploadRequiredNumberOfPhotosIn")}: ${formattedSections}`
            });
            return;
        }

        this.setState({ errorMessage: "" });
        this.props.callAPI(evidence, (errorMessage) => {
            this.setState({ errorMessage: errorMessage });
        });
    };


    handlePhotoUploadGeneric = (event, sectionKey) => {
        const files = Array.from(event.target.files);
        if (!files.length) return;

        const limit = PHOTO_UPLOAD_LIMITS[sectionKey];
        const currentPhotos = this.state.evidence[sectionKey] || [];
        const remainingSlots = limit - currentPhotos.length;

        if (remainingSlots <= 0) {
            this.setState({ errorMessage: Strings("uploadLimitReached") });
            return;
        }

        const filesToProcess = files.slice(0, remainingSlots);


        filesToProcess.forEach((file, index) => {
            const fileExtension = Utility.getFileExtension(file);
            if (!_.includes(FILE_CONFIGURATIONS.allowedImageExtensions, fileExtension)) {
                this.setState({ errorMessage: Strings("fileExtension") });

                return;
            }

            if (file.size > MOTORCYCLE_FILE_SIZE) {
                this.setState({ errorMessage: Strings("sizeIsTooLarge") });

                return;
            }

            try {
                Resizer.imageFileResizer(
                    file,
                    1024,
                    800,
                    fileExtension,
                    100,
                    0,
                    (resizedFile) => {
                        const previewUrl = URL.createObjectURL(resizedFile);

                        this.setState((prevState) => {
                            const updatedPhotos = [...prevState.evidence[sectionKey], {
                                file: resizedFile,
                                preview: previewUrl
                            }];

                            return {
                                evidence: {
                                    ...prevState.evidence,
                                    [sectionKey]: updatedPhotos,
                                },
                                errorMessage: ""
                            };
                        });
                    },
                    "file"
                );
            } catch (err) {
                this.setState({ errorMessage: Strings("imageUploadFailed") });
            }
        });

        event.target.value = '';
    };




    removePhotoGeneric = (sectionKey, index, documentId) => {
        documentId && this.props.handleDeleteEvidenceDocumentAction(documentId);
        this.setState((prevState) => {
            const updatedSection = [...prevState.evidence[sectionKey]];
            updatedSection.splice(index, 1);

            return {
                evidence: {
                    ...prevState.evidence,
                    [sectionKey]: updatedSection
                }
            };
        });
    };


    renderPhotoSection = (sectionKey) => {
        const photos = this.state.evidence[sectionKey] || [];

        const limit = PHOTO_UPLOAD_LIMITS[sectionKey];

        return (
            <div className="mb-4">
                <div className="d-flex flex-wrap gap-3 mt-3">
                    {photos.map((photo, index) => {
                        const placeholderRef = React.createRef();
                        return (
                            <div key={index} className="position-relative">
                                <div
                                    ref={placeholderRef}
                                    style={{
                                        width: '10rem',
                                        height: '10rem',
                                        borderRadius: '0.5rem',
                                        backgroundColor: '#e0e0e0',
                                        marginBottom: '1rem',
                                        flexShrink: 0,
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        zIndex: 1
                                    }}
                                />
                                <img
                                    src={photo.preview}
                                    alt={""}
                                    onClick={() => this.handlePhotoClick(photo.preview)}
                                    onLoad={() => {
                                        if (placeholderRef.current) {
                                            placeholderRef.current.style.display = 'none';
                                        }
                                    }}
                                    style={{
                                        width: '10rem',
                                        height: '10rem',
                                        objectFit: 'cover',
                                        borderRadius: '0.5rem',
                                        marginBottom: '1rem',
                                        flexShrink: 0,
                                        cursor: 'pointer',
                                        position: 'relative',
                                        zIndex: 2,
                                        border: '2px solid #ccc'
                                    }}
                                />
                                <span
                                    onClick={() => this.removePhotoGeneric(sectionKey, index, photo.documentId)}
                                    style={{
                                        position: 'absolute',
                                        top: '0.25rem',
                                        right: '0.25rem',
                                        fontWeight: 'bold',
                                        background: '#fff',
                                        borderRadius: '50%',
                                        textAlign: 'center',
                                        lineHeight: '1.5rem',
                                        cursor: 'pointer',
                                        boxShadow: '0 0 4px rgba(0,0,0,0.2)',
                                        zIndex: 3
                                    }}
                                >
                                    {!this.props.disableTextField && <img
                                        src={cross}
                                        className='crossIcon'
                                        alt=''
                                    />}
                                </span>
                            </div>
                        );
                    })}

                    {photos.length < limit && (
                        <label
                            className="d-flex justify-content-center align-items-center"
                            style={{
                                width: '10rem',
                                height: '10rem',
                                border: '0.125rem dashed #ccc',
                                borderRadius: '0.5rem',
                                backgroundColor: '#f8f8f8',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s ease',
                                marginBottom: '1rem',
                                flexShrink: 0
                            }}
                        >
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                style={{ display: 'none' }}
                                onChange={(e) => this.handlePhotoUploadGeneric(e, sectionKey)}
                            />
                            <span style={{ fontSize: '2rem', color: '#888' }}>+</span>
                        </label>
                    )}
                </div>
            </div>
        );
    };



    renderButtons = () => {
        const { isUploading } = this.props;
        return (
            <Row className='modalButton justify-content-between ps-3'>
                <Col md={4} className='text-start'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goBack}
                        disabled={isUploading || this.props.showLoadingModalState}
                    >
                        {Strings("Back").toUpperCase()}
                    </Button>
                </Col>
                <Col md={4} className='d-flex justify-content-end pe-4'>
                    <Button
                        className='buttonBackground'
                        onClick={this.validateData}
                        disabled={isUploading || this.props.showLoadingModalState}
                    >
                        {isUploading ? Strings("uploading") + "..." : Strings("Save")}
                    </Button>
                </Col>
            </Row>
        )
    }

    renderUploadProgress = () => {
        const { isUploading, uploadProgress, totalFiles, uploadedFiles, errorMessage } = this.props;

        if (!isUploading && !errorMessage) return null;

        return (
            <div className="ps-3 mb-3">

                <div className="upload-progress-container pe-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <span>{Strings("uploadingFiles")}: {uploadedFiles}/{totalFiles}</span>
                        <span>{Math.round(uploadProgress)}%</span>
                    </div>
                    <div className="progress" style={{ height: '20px' }}>
                        <div
                            className="progress-bar bg-success"
                            role="progressbar"
                            style={{ width: `${uploadProgress}%` }}
                            aria-valuenow={uploadProgress}
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {Math.round(uploadProgress)}%
                        </div>
                    </div>
                </div>

            </div>
        );
    };

    handlePhotoClick = (photoUrl) => {
        this.setState({ selectedPhoto: photoUrl });
    };
    closeImagePreview = () => {
        this.setState({ selectedPhoto: null });
    };

    renderImagePreviewModal = () => {
        const { selectedPhoto } = this.state;
        if (!selectedPhoto) return null;

        return (
            <UserModal
                open={true}
                modalCloseOnEsc={false}
                modalCloseOnOverlayClick={false}
                modalShowCloseIcon={false}
                headerText={Strings("Image")}
                modalImage={selectedPhoto}
                modalButtonOk={{
                    text: Strings("Ok"),
                    onClick: this.closeImagePreview,
                }}
                showHr={true}
                modalButtonCancel={null}
                evidenceUpload={true}
            />
        );
    };

    renderAccordions = () => {
        return (
            <Accordion
                activeKey={this.state.activeAccordionKey}
                onSelect={(key) => this.setState({ activeAccordionKey: key })}
                className="container-fluid"
            >
                <Accordion.Item className="accordions" eventKey='0'>
                    <Accordion.Header>
                        <div id='collapse' className='collapseHeading w-100 subHeading dropdown-toggle'>
                            {this.props.selectedLoanType === LOAN_TYPES.PERSONAL_LOAN
                                ? Strings("LOCATION_PHOTOS")
                                : Strings("LOCAL_PHOTOS")}
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        {this.renderPhotoSection(EVIDENCE_SECTIONS_OBJECT.LOCAL_PHOTO)}
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item className="accordions" eventKey='1' >
                    <Accordion.Header>
                        <div id='collapse' className='collapseHeading w-100 subHeading dropdown-toggle'>
                            {this.props.selectedLoanType === LOAN_TYPES.PERSONAL_LOAN
                                ? Strings("DOCUMENT_PHOTOS")
                                : Strings("INVOICES")}
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        {this.renderPhotoSection(EVIDENCE_SECTIONS_OBJECT.INVOICE)}
                    </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item className="accordions" eventKey='2'>
                    <Accordion.Header>
                        <div id='collapse' className='collapseHeading w-100 subHeading dropdown-toggle'>
                            {Strings("PHOTOID")}
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        {this.renderPhotoSection(EVIDENCE_SECTIONS_OBJECT.PHOTOID)}
                    </Accordion.Body>
                </Accordion.Item>
                {this.state.evidence?.APPLICATION_SIGNATURE?.length > 0 && <Accordion.Item className="accordions" eventKey='4'>
                    <Accordion.Header>
                        <div id='collapse' className='collapseHeading w-100 subHeading dropdown-toggle'>
                            {Strings("APPLICATION_SIGNATURE")}
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        {this.renderPhotoSection(EVIDENCE_SECTIONS_OBJECT.APPLICATION_SIGNATURE)}
                    </Accordion.Body>
                </Accordion.Item>}
                {this.props.selectedLoanType === LOAN_TYPES.EXTERNAL_FACTORING &&
                    <Accordion.Item className="accordions" eventKey='3'>
                        <Accordion.Header>
                            <div id='collapse' className='collapseHeading w-100 subHeading dropdown-toggle'>
                                {Strings("EXTERNAL_INVOICE")}
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            {this.renderPhotoSection(EVIDENCE_SECTIONS_OBJECT.EXTERNAL_INVOICE)}
                        </Accordion.Body>
                    </Accordion.Item>}


            </Accordion>
        )
    }
    renderErrors = () => {
        return (
            <Row className="errors mb-0 ps-0">
                <span>
                    {this.state.errorMessage}
                </span>
            </Row>
        )
    }
    renderApplicationSignatureWarning = () => {
        return (
            <Row className="warningText pt-3">
                <span>
                    {Strings("ApplicationSignatureWarning")}
                </span>
            </Row>
        )
    }
    render() {

        return (
            <Col md={12}>
                {this.state.errorMessage && this.renderErrors()}
                {(this.state.evidence?.APPLICATION_SIGNATURE?.length !== 0 && (this.props.applyLoanConfig?.loanStatus === "" || this.props.applyLoanConfig?.loanStatus === LOAN_APPLICATION_STATUS.created || this.props.applyLoanConfig?.loanStatus === LOAN_APPLICATION_STATUS.incomplete)) && this.renderApplicationSignatureWarning()}
                {this.props.isUploading && this.renderUploadProgress()}
                {this.renderImagePreviewModal()}
                {this.renderAccordions()}
                <hr className="opacity-100 mb-2 ms-2 me-2 mt-0" />
                {this.renderButtons()}
            </Col>
        );
    }
}

export default Evidence;
